import { Component } from '@angular/core';
import { PDP_CALL_SOURCE } from '@shared/models/shared.model';
import { WishListItemComponent } from '@spartacus/cart/wish-list/components';
import { ProductListItemContext, ProductListItemContextSource, IconComponent } from '@spartacus/storefront';
import { ICON_TYPE } from '../../model/wish-list-icon.model';
import { NgIf } from '@angular/common';
import { RouterLink } from '@angular/router';
import { EfaAddToCartComponent } from '../../../add-to-cart/components/efa-add-to-cart/efa-add-to-cart.component';
import { TranslatePipe, UrlPipe } from '@spartacus/core';

@Component({
    selector: 'app-efa-wish-list-item',
    templateUrl: './efa-wish-list-item.component.html',
    providers: [
        ProductListItemContextSource,
        {
            provide: ProductListItemContext,
            useExisting: ProductListItemContextSource,
        },
    ],
    imports: [NgIf, RouterLink, EfaAddToCartComponent, IconComponent, TranslatePipe, UrlPipe]
})
export class EfaWishListItemComponent extends WishListItemComponent {

  iconTypes = ICON_TYPE;

  readonly pdpCallSource: PDP_CALL_SOURCE = PDP_CALL_SOURCE.WISHLIST;
}
